import { coerceToDate } from '@chatwoot/utils';

/** `2026-03-21` — o formato que o seletor de data manda pro filtro. */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Converte um valor de filtro em Date, tratando data pura como data LOCAL.
 *
 * Existe porque `coerceToDate` do @chatwoot/utils erra o dia inteiro em fuso
 * negativo. Ela faz `new Date('2026-03-21')`, que o JS lê como meia-noite
 * **UTC** — em São Paulo (UTC-3) isso já é 20/03 às 21h local. Em seguida ela
 * chama `setHours(0,0,0,0)`, que zera no fuso **local**, e o resultado final
 * é 20/03 00:00. A data volta um dia.
 *
 * Efeito em produção: "criadas antes de 21/03" escondia as conversas do dia
 * 20, e "criadas depois de 19/03" trazia as do dia 18. Todo filtro por data
 * do escritório estava deslocado em um dia. Três testes em
 * `filterHelpers.spec.js` já falhavam por causa disso — passavam só quando a
 * suíte rodava com TZ=UTC, que é o que o CI usa.
 *
 * Aqui a data pura é montada componente a componente (`new Date(y, m-1, d)`),
 * que é meia-noite local por definição, sem passar por UTC. Qualquer outro
 * formato (timestamp, ISO com hora) segue pra `coerceToDate`, que acerta —
 * são instantes absolutos, não têm ambiguidade de fuso.
 *
 * @param {string|number|null|undefined} value
 * @returns {Date|null}
 */
export const coerceFilterDate = value => {
  if (typeof value === 'string' && DATE_ONLY.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  return coerceToDate(value);
};
